export const appointmentData = [
  {
    id: 1,
    patient: "Timmy Donaldson",
    day: new Date(),
    consulted: true,
    doctor: "Prof. Akari Yoshino",
  },
  {
    id: 2,
    patient: "Bobbie Martel",
    day: new Date(),
    consulted: false,
    doctor: "Prof. Dr. Theodor Jackson",
  },
  {
    id: 3,
    patient: "Elisa Daniel",
    day: new Date(),
    consulted: true,
    doctor: "Dr. Jasmine Carpanter",
  },
];

export const doctorData = [
  {
    id: 1,
    name: "Prof. Akari Yoshino",
    dep: "Cardiology",
    img: "./img/dr1.png",
  },
  {
    id: 2,
    name: "Dr. Jasmine Carpanter",
    dep: "Radiolgy",
    img: "./img/dr2.jpg",
  },
  {
    id: 3,
    name: "Prof. Dr. Theodor Jackson",
    dep: "Orthopedy",
    img: "./img/dr3.png",
  },
  {
    id: 4,
    name: "Dr. Nari Chung",
    dep: "Gastroentogoly",
    img: "./img/dr4.png",
  },
  {
    id: 5,
    name: "Prof. Dr. Benjamin Daley",
    dep: "Surgery",
    img: "./img/dr9.jpg",
  },
  {
    id: 6,
    name: "Dr. Kristensen Abraham",
    dep: "Neurology",
    img: "./img/dr6.jpg",
  },
  {
    id: 7,
    name: "Dr.Asley Graham",
    dep: "Pediatry",
    img: "./img/dr7.jpg",
  },
  {
    id: 8,
    name: "Dr. Mary Motley",
    dep: "Oncology",
    img: "./img/dr8.jpg",
  },
];
